import { Avatar, Image, Tag } from "antd";
import { tagsBageStatus } from "../../helpers/tagsBage";
import { t } from "i18next";
import { formatLogoBankByBankCode } from "../../utils";
import { FormatMerchant } from "../../helpers/formatMerchant";
import moment from "moment";

const formatDate = "YYYY-MM-DD HH:mm:ss";

export const itemsDescriptions = ({
  resAllDataMerchang,
  apiResponse,
  previewImage,
}) => {
  // ตรวจสอบความถูกต้องของข้อมูลเบื้องต้น
  if (!apiResponse || !apiResponse?.data) {
    return null;
  }

  let res = apiResponse?.data;

  // --- การเตรียมข้อมูล ---
  // การจัดรูปแบบวันที่
  const transDateTime = res?.transDateTime
    ? moment(res.transDateTime).format(formatDate)
    : null;
  const createdAt = res?.createdAt
    ? moment(res.createdAt).format(formatDate)
    : null;

  // การจัดรูปแบบตัวเลข
  const verifyFee =
    res?.verifyFee !== undefined && parseFloat(res.verifyFee) !== 0
      ? Intl.NumberFormat().format(parseFloat(res.verifyFee).toFixed(2))
      : null;

  const amount =
    res?.amount !== undefined && parseFloat(res.amount) !== 0
      ? Intl.NumberFormat().format(parseFloat(res.amount).toFixed(2))
      : null;

  // ข้อมูลร้านค้า
  const merchantInfo = FormatMerchant(resAllDataMerchang, res?.merchantId);
  const merchantName = merchantInfo?.name;
  const merchantId = res?.merchantId;

  // ข้อมูลผู้ส่ง (Sender)
  const senderBankData = formatLogoBankByBankCode(res?.senderBank);
  const senderbankLogo = senderBankData?.bankLogo;
  const formatTransRef = senderBankData?.lableRef;

  // ข้อมูลผู้รับ (Receiver)
  const receiverBankUrl = formatLogoBankByBankCode(res?.receiverBank);
  const receiverbankLogo = receiverBankUrl?.bankLogo;

  // --- การสร้างรายการ Descriptions ---
  const items = [
    // ID
    res?.id && {
      key: "1.2",
      label: "ID",
      children: <>{res.id}</>,
    },
    // สลิปที่ตรวจสอบ (ต้องมี previewImage)
    previewImage && {
      key: "4.1",
      label: "สลิปที่ตรวจสอบ",
      children: (
        <>
          <Image
            src={previewImage || ""}
            alt="Preview"
            className={`img-fluid img-thumbnail`}
            style={{
              width: 50,
              border: "1px solid #ddd",
            }}
            preview={true}
          />
        </>
      ),
    },
    // From Account (เช็คบัญชีผู้ส่งหรือชื่อ)
    (res?.senderAccountNo || res?.senderName) && {
      key: "8",
      label: t("จากบัญชี"),
      children: (
        <>
          <Avatar size="small" src={senderbankLogo} /> - {res?.senderAccountNo}
          <br />
          {res?.senderName}
        </>
      ),
    },
    // To Account (เช็คบัญชีผู้รับหรือชื่อ)
    (res?.receiverAccountNo || res?.receiverName) && {
      key: "9",
      label: t("ไปยังบัญชี"),
      children: (
        <>
          <Avatar size="small" src={receiverbankLogo} /> -{" "}
          {res?.receiverAccountNo}
          <br />
          {res?.receiverName}
        </>
      ),
    },
    // ร้านค้า
    (merchantName || merchantId) && {
      key: "4",
      label: "ร้านค้า",
      children: (
        <>
          {merchantName} ({merchantId})
        </>
      ),
    },
    // วันที่-เวลา (ตามสลิป)
    transDateTime && {
      key: "1",
      label: "วันที่-เวลา (ตามสลิป)",
      children: <>{transDateTime}</>,
    },
    // วันที่-เวลา (ในระบบ)
    createdAt && {
      key: "1.1",
      label: "วันที่-เวลา (ในระบบ)",
      children: <>{createdAt}</>,
    },
    // TransRef.
    res?.transRef && {
      key: "2",
      label: formatTransRef || "TransRef.",
      children: <>{res.transRef}</>,
    },
    // payEasyRef.
    res?.payEasyRef && {
      key: "3",
      label: "payEasyRef.",
      children: <>{res.payEasyRef}</>,
    },
    // จำนวนเงิน
    amount && {
      key: "5",
      label: "จำนวนเงิน",
      children: <>{amount}.-</>,
    },
    // ค่าธรรมเนียม
    verifyFee && {
      key: "6",
      label: "ค่าธรรมเนียม",
      children: <>{verifyFee}.-</>,
    },
    // สถานะตรวจสอบ (ควรแสดงเสมอเมื่อมี response)
    res?.status && {
      key: "7",
      label: "สถานะตรวจสอบ",
      children: <Tag color={tagsBageStatus(res.status)}>{res.status}</Tag>,
    },
  ].filter(Boolean); // กรองเอาเฉพาะรายการที่ไม่เป็น false/null

  return items;
};
